<div class="field">
  <div class="label">{{ label }}<ng-container *ngIf="editMode && required">*</ng-container></div>

  <ng-container *ngIf="!editMode; else editField">
    <div class="value-box">
      <span *ngIf="prefix">{{ prefix }} </span>

      {{ displayValue }}

      <span *ngIf="suffix"> {{ suffix }} </span>
    </div>
  </ng-container>

  <ng-template #editField>
    <div class="field-edit">
      <ng-container *ngIf="isInput; else Select">
        <div class="value-box-with-prefix" *ngIf="prefix">
          <span class="value-box-prefix">{{ prefix }}</span>

          <input
            class="value-box"
            [type]="type"
            [value]="value"
            (input)="onInput($event)"
            (blur)="onTouched()"
            [attr.maxlength]="maxlength"
            [attr.min]="min"
          />
        </div>

        <div class="value-box-with-suffix" *ngIf="suffix && !prefix">
          <input
            class="value-box"
            [type]="type"
            [value]="value"
            (input)="onInput($event)"
            (blur)="onTouched()"
            [attr.maxlength]="maxlength"
            [attr.min]="min"
          />
          <span class="value-box-suffix">{{ suffix }}</span>
        </div>

        <input
          *ngIf="!prefix && !suffix"
          class="value-box"
          [type]="type"
          [value]="value"
          (input)="onInput($event)"
          (blur)="onTouched()"
          [attr.maxlength]="maxlength"
          [attr.min]="min"
        />
      </ng-container>

      <ng-template #Select>
        <select class="value-box" [value]="value" (change)="onSelect($event)" (blur)="onTouched()">
          <option *ngFor="let opt of options" [ngValue]="opt.value" [selected]="opt.value === value">
            {{ opt.translate ? (opt.label | translate) : opt.label }}
          </option>
        </select>
      </ng-template>

      <div class="error-message" *ngIf="requiredError">
        {{ "common.required" | translate }}
      </div>
    </div>
  </ng-template>
</div>
